import React, { Component } from 'react';
import CoursePicker from '../../../components/CoursePicker';

class Home extends Component {
  render () {
    return (
      <span>
        <CoursePicker autoStart rootPath={'get-started'} />
      </span>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Main/GetStarted/index.js